import io from 'socket.io-client';

/**
 * 自定义websocket类
 * @class Socket
 */
export default class Socket {
  constructor(userId, userType) {
    this.userId = userId;
    this.userType = userType;
    this.init();
  }

  socket = null;

  init() {
    if (this.socket == null) {
      const url = ENV_CONFIG.socketUrl;
      console.log(url);
      this.socket = io(url);
      this.socket.on('connect', () => {
        console.log(`#################### socket连接成功, 当前连接id: ${this.socket.id} ####################`);
        // 发送连接id和用户信息给后端
        this.socket.emit('connected', {
          userId: this.userId,
          userType: this.userType,
          socketId: this.socket.id,
        });
      });
      this.socket.on('disconnect', () => {
        console.log('#################### socket连接断开 ####################');
        // this.socket.open();
      });
    }
  }

  on(message, callback) {
    this.init();
    this.socket.on(message, callback);
  }

  off(message, callback) {
    this.init();
    this.socket.off(message, callback);
  }

  close() {
    this.socket && this.socket.close();
  }
}
